import { render, staticRenderFns } from "./SafetyMSDS.vue?vue&type=template&id=20d1be7a&scoped=true&"
import script from "./SafetyMSDS.vue?vue&type=script&lang=js&"
export * from "./SafetyMSDS.vue?vue&type=script&lang=js&"
import style0 from "./SafetyMSDS.vue?vue&type=style&index=0&id=20d1be7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d1be7a",
  null
  
)

export default component.exports